import * as React from "react";
import {Component } from "react";

import "./maintenance.scss";
import {MaintenanceConfiguration} from "../../config/maintenance-configuration";
import {Icon} from "../icon/icon";

export interface MaintenanceProps {
    config: MaintenanceConfiguration[];
}

export class Maintenance extends Component<MaintenanceProps, any> {

    constructor(props: MaintenanceProps) {
        super(props);
        this.state = {visible: true};
        this.handleDismiss = this.handleDismiss.bind(this);
    }
    handleDismiss = () => {
        this.setState({ visible: false });
    };
    render(): JSX.Element | null {
        if (!this.state.visible) {
            return null;
        }
        const now = new Date();
        const maintenance = this.props.config.filter((m: MaintenanceConfiguration) =>
            // only display message in configured time frame
            now > m.from && now < m.to
        );

        const message: JSX.Element[] = [];
        maintenance.forEach((m: MaintenanceConfiguration, index) => {
            message.push(<p key={index}>{m.message}</p>);
        });

        if (message.length === 0) {
            return null;
        }
        return(
            <div className="maintenance">
                {message}
                <Icon onClick={this.handleDismiss} name="navigate_cross"
                    title={"Hinweis schliessen"} />
            </div>
        );
    }
}
